<template>
  <section class="form-list" v-loading="isLoading">
    <el-card shadow="never">
      <div slot="header">离职申请 #{{ apply.id }}</div>
      <div class="offboard-info">
        <div class="offboard-info-row"><span class="offboard-info-label">员工</span><span>{{ apply.nickname }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">用户名</span><span>{{ apply.username }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">手机号</span><span>{{ apply.phone || '未填写' }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">门店</span><span>{{ apply.store_name | formatStoreName }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">职位</span><span>{{ apply.role_name || '-' }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">类型</span><span>{{ leaveTypeName(apply.leave_type) }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">原因</span><span>{{ apply.leave_reason }}</span></div>
        <div class="offboard-info-row"><span class="offboard-info-label">状态</span><el-tag :type="stateTag">{{ stateName }}</el-tag></div>
        <div class="offboard-info-row"><span class="offboard-info-label">审核备注</span><span>{{ apply.remark || '' }}</span></div>
      </div>

      <div style="margin-top:16px;">
        <template v-if="canReview">
          <el-button type="success" :loading="isSaving" @click="pass">通过离职</el-button>
          <el-button type="danger" :loading="isSaving" @click="reject">驳回</el-button>
        </template>
        <el-button icon="el-icon-view" @click="openPersonnel">任职记录</el-button>
        <el-button @click="back">返回</el-button>
      </div>
    </el-card>

    <v-dialog-personnel
      v-model="personnelDialogVisible"
      :administrator-id="personnelDialogAdministratorId"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { applyStates } from '@/enums/applyStates';
import { leaveTypes } from '@/enums/leaveTypes';
import RouteConfig from '@/router/config';
import { offboardApplyShow, offboardApplyReview } from '@/api/personnel';
import VDialogPersonnel from '@/components/VDialogPersonnel/index.vue';

export default {
  name: RouteConfig.administratorOffboardApplyDetail.name,
  components: {
    VDialogPersonnel,
  },
  data: () => ({
    RouteConfig,
    isLoading: false,
    isSaving: false,
    apply: {},
    remark: '',
    personnelDialogVisible: false,
    personnelDialogAdministratorId: 0,
  }),
  computed: {
    stateName() {
      for (const key in applyStates) {
        if (Number(applyStates[key].value) === Number(this.apply.apply_state)) return applyStates[key].name;
      }
      return '';
    },
    stateTag() {
      for (const key in applyStates) {
        if (Number(applyStates[key].value) === Number(this.apply.apply_state)) return applyStates[key].tagType || 'info';
      }
      return 'info';
    },
    canReview() {
      if (Number(this.apply.apply_state) !== 2) return false;
      if (!this.isAdministratorOrManager) return false;

      const targetId = Number(this.apply.administrator_id);
      const addAdministratorId = Number(this.apply.add_administrator_id);
      const roleId = Number(this.apply.administrator_role_id);
      const userId = Number(this.userId);

      // 超级管理员的离职：仅另一名超级管理员可审核，且不能是本人/发起人
      if (roleId === 1) {
        if (!this.isAdministrator) return false;
        if (targetId === userId) return false;
        if (addAdministratorId === userId) return false;
        return true;
      }

      // 店长/超管代发起的离职：仅超级管理员可审核
      if (addAdministratorId !== targetId) {
        return this.isAdministrator;
      }

      // 员工本人发起的普通员工离职：本人不能审
      if (targetId === userId) return false;

      // 店长不能审店长及以上
      if (!this.isAdministrator && roleId === 2) return false;

      // 店长不能审自己发起的离职
      if (!this.isAdministrator && addAdministratorId === userId) return false;

      return true;
    },
    ...mapGetters(['userId', 'isAdministrator', 'isManager', 'isAdministratorOrManager']),
  },
  async mounted() {
    this.isLoading = true;
    const { isError, data } = await offboardApplyShow(this.$route.params.id);
    this.isLoading = false;
    if (isError) return;
    this.apply = data;
    this.remark = data.remark || '';
  },
  methods: {
    leaveTypeName(value) {
      const item = leaveTypes[Object.keys(leaveTypes).find(key => leaveTypes[key].value === value)] || {};
      return item.name || '';
    },
    openPersonnel() {
      this.personnelDialogAdministratorId = this.apply.administrator_id;
      this.personnelDialogVisible = true;
    },
    async doReview(isPassed, isEmergency = false, emergencyReason = '') {
      this.isSaving = true;
      const data = {
        is_passed: isPassed ? 1 : 0,
        remark: this.remark,
        is_emergency: isEmergency ? 1 : 0,
        reason: emergencyReason,
      };
      const { isError } = await offboardApplyReview(this.apply.id, data);
      this.isSaving = false;
      if (isError) return;
      this.$message.success(isPassed ? '已通过离职' : '已驳回');
      this.back();
    },
    pass() {
      this.$confirm('确认通过该离职申请吗？通过后将关闭该门店任职记录。', '提示', { type: 'warning' })
        .then(() => this.doReview(true)).catch(() => {});
    },
    reject() {
      this.$prompt('请输入驳回原因', '驳回', {
        inputValue: this.remark,
        inputValidator: value => (value && value.length >= 2 ? true : '请输入至少 2 个字符'),
      }).then(({ value }) => {
        this.remark = value;
        this.doReview(false);
      }).catch(() => {});
    },
    back() {
      RouteConfig.administratorOffboardApplyList.push();
    },
  },
};
</script>

<style scoped>
.offboard-info { max-width: 720px; }
.offboard-info-row { display: flex; align-items: center; padding: 8px 0; border-bottom: 1px solid #f0f0f0; }
.offboard-info-row:last-child { border-bottom: none; }
.offboard-info-label { width: 90px; flex-shrink: 0; color: #909399; }
</style>
